import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPrivacy = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 18.0005 21.7936",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Icon",
		d: "M6.00026 10.432L8.00026 12.432L12.5003 7.932M17.0003 10.932C17.0003 15.8404 11.6463 19.4104 9.69826 20.5469C9.47686 20.676 9.36617 20.7406 9.20995 20.7741C9.08871 20.8001 8.91182 20.8001 8.79058 20.7741C8.63436 20.7406 8.52367 20.676 8.30227 20.5469C6.35423 19.4104 1.00026 15.8404 1.00026 10.932V6.1496C1.00026 5.35009 1.00026 4.95033 1.13103 4.6067C1.24654 4.30314 1.43425 4.03228 1.67792 3.81753C1.95376 3.57444 2.32806 3.43408 3.07667 3.15335L8.43847 1.14267C8.64636 1.06471 8.75031 1.02573 8.85725 1.01028C8.9521 0.996573 9.04843 0.996573 9.14328 1.01028C9.25022 1.02573 9.35417 1.06471 9.56206 1.14267L14.9239 3.15335C15.6725 3.43408 16.0468 3.57444 16.3226 3.81753C16.5663 4.03228 16.754 4.30314 16.8695 4.6067C17.0003 4.95033 17.0003 5.35009 17.0003 6.1496V10.932Z",
		stroke: "var(--stroke-0, #DFCBF5)",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPrivacy;
